// extracted by mini-css-extract-plugin
export default {"AggregatorFormRoot":"AggregatorFormRoot---dmNP1","AggregatorFormContent":"AggregatorFormContent---OeYzB"};